import * as Yup from 'yup';

export default Yup.object({
  name: Yup.string().required('Please enter a name'),
  content: Yup.string().required('Please enter some content'),
});
